import { render, staticRenderFns } from "./DashboardInformador.vue?vue&type=template&id=b997445e&lang=true"
import script from "./DashboardInformador.vue?vue&type=script&lang=js"
export * from "./DashboardInformador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports